import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
import {
  POST_SELECTED_CHEF,
  POST_SELECTED_WHEN
} from "../../store/action";
import { t } from "../../translations";
import { GET } from "../constants/request-type";
import { service_api } from "../constants/url";
import { MakeRequestAsync } from "../functions/axios";
import { decryptSingleData } from "../functions/cryptojs";
import { dayPlusOne, todayDate } from "../functions/dateFunctions";
import { sessionHandler } from "../functions/sessionHandler";
import "../styles/layout.css";

// image importation

import Calendar from "../elements/calendar";
import CategorySection from "../elements/category-section";
import PromoBar from "../elements/promo-bar";
import SectionFood from "../elements/section-food";

import { configureCrisp } from "../../utils/crispConfig";
import { createLogger } from "../../utils/logger";

const logger = createLogger("LayoutHomeChef");

const LayoutHomeChef = () => {
  const [load, setLoad] = useState(true);


  const [selectedCuisine, setSeclectedCuisine] = useState("all");
  const [cuisineList, setCuisineList] = useState([]);

  const [culinariansList, setCulinariansList] = useState([]);

  const [promoBar, setPromoBar] = useState([]);


  const [selectedTab, setSelectedTab] = useState("discover-chefs");

  let selectedWhen = useSelector((state) => state.selectedWhen);
  let selectedLang = useSelector((state) => state.lang);
  let selectedZip = useSelector((state) => state.selectedZip);
  let selectedChef = useSelector((state) => state.selectedChef);
  let user = useSelector((state) => state.user);

  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    configureCrisp({
      autoload: true,
      lockMaximized: false,
      lockFullview: false
    });
    initialData();
  }, []);

  const initialData = async () => {
    const tday = dayPlusOne();
    const today = todayDate();

    // If no date is selected or it's in the past
    if (selectedWhen === null || selectedWhen < today) {
      // For restaurants, allow today; for chefs, use tomorrow
      const defaultDate = selectedTab === "discover-restaurants" ? today : tday;
      WhenDate(defaultDate);
    }


    const request_details_cuisine = {
      type: GET,
      url: service_api,
      route: "geographical/get-actif",
      data: null,
      token: null
    };

    const request_details_promo = {
      type: GET,
      url: service_api,
      route: "discount/get-actif",
      data: null,
      token: null
    };

    // Check if we have coordinates from URL params
    const urlParams = new URLSearchParams(window.location.search);
    const lat = urlParams.get("lat");
    const lng = urlParams.get("lng");
    const metropolitanAreaFromURL = urlParams.get("metropolitan_area");

    // Get user's timezone
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    // Get metropolitan area from URL params first, then fallback to session storage
    const locationData = sessionHandler("user_location", null, "get");
    const metropolitanArea =
      metropolitanAreaFromURL ||
      locationData?.metropolitan_area?.metropolitan_area ||
      "Unknown";

    logger.log("🏙️ Metropolitan area detection:", {
      fromURL: metropolitanAreaFromURL,
      fromSession: locationData?.metropolitan_area?.metropolitan_area,
      final: metropolitanArea
    });

    // Build location parameter dynamically based on available data
    const locationParam =
      lat && lng ? `lat=${lat}&lng=${lng}` : `zip=${selectedZip}`;

    const request_details_chef = {
      type: GET,
      url: service_api,
      route: `user/get-all-chef-period?date=${selectedWhen}&${locationParam}&country=${selectedCuisine}&timezone=${userTimezone}&metropolitan_area=${encodeURIComponent(metropolitanArea)}`,
      token: null
    };

    try {
      // Fetch all data in parallel for better performance
      const [response_promo, response_cuisine, response_chef] = await Promise.all([
        MakeRequestAsync(request_details_promo),
        MakeRequestAsync(request_details_cuisine),
        MakeRequestAsync(request_details_chef)
      ]);

      // Process promo data
      const decryptedDataPromo = decryptSingleData(
        response_promo.data.discount
      );
      logger.log(decryptedDataPromo);
      setPromoBar(decryptedDataPromo);

      // Process cuisine data
      const decryptedDataCuisine = decryptSingleData(
        response_cuisine.data.geographical
      );
      logger.log(decryptedDataCuisine);
      setCuisineList(decryptedDataCuisine);

      // Process chef data
      const decryptedDataChef = decryptSingleData(
        response_chef.data.user
      );
      logger.log(decryptedDataChef);
      setCulinariansList(decryptedDataChef);
    } catch (err) {
      logger.log("We couldn't fetch data: ", err?.response?.data?.message);
    } finally {
      setLoad(false);
    }
  };

  const updateChefData = async (date, cuisine) => {
    setLoad(true);

    // Check if we have coordinates from URL params
    const urlParams = new URLSearchParams(window.location.search);
    const lat = urlParams.get("lat");
    const lng = urlParams.get("lng");
    const metropolitanAreaFromURL = urlParams.get("metropolitan_area");

    // Get user's timezone
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    // Get metropolitan area from URL params first, then fallback to session storage
    const locationData = sessionHandler("user_location", null, "get");
    const metropolitanArea =
      metropolitanAreaFromURL ||
      locationData?.metropolitan_area?.metropolitan_area ||
      "Unknown";

    logger.log("🏙️ Metropolitan area detection:", {
      fromURL: metropolitanAreaFromURL,
      fromSession: locationData?.metropolitan_area?.metropolitan_area,
      final: metropolitanArea
    });

    // Build location parameter dynamically based on available data
    const locationParam =
      lat && lng ? `lat=${lat}&lng=${lng}` : `zip=${selectedZip}`;

    const selectedDate = date !== null ? date : selectedWhen;
    const selectedCountry = cuisine !== null ? cuisine : selectedCuisine;

    const request_details_chef = {
      type: GET,
      url: service_api,
      route: `user/get-all-chef-period?date=${selectedDate}&${locationParam}&country=${selectedCountry}&timezone=${userTimezone}&metropolitan_area=${encodeURIComponent(metropolitanArea)}`,
      token: user?.refresh_token || null
    };

    try {
      const response = await MakeRequestAsync(request_details_chef);
      const decryptedData = decryptSingleData(response.data.user);
      logger.log(decryptedData);
      setCulinariansList(decryptedData);
    } catch (err) {
      logger.log("We couldn't fetch data: ", err?.response?.data?.message);
    } finally {
      setLoad(false);
    }
  };

  const WhenDate = (value) => dispatch(post_selected_when(value));

  const WhichChef = (value) => dispatch(post_selected_chef(value));

  return (
    <div className="global-block">
      <div className="full-block">
        {/* Tu dois ajouter tout les autre compasant du projet ici */}

        <CategorySection
          list={cuisineList}
          lang={selectedLang}
          selectedCuisine={selectedCuisine}
          setCuisine={(data) => {
            setSeclectedCuisine(data);
            updateChefData(null, data);
          }}
        />

        {promoBar.length > 0 && (
          <PromoBar list={promoBar} lang={selectedLang} />
        )}

        <Calendar
          title={t("layout.select_delivery_date", selectedLang)}
          lang={selectedLang}
          selectedDate={selectedWhen}
          allowToday={true}
          setDay={(data) => {
            WhenDate(data);
            updateChefData(data, null);

            // Preserve all parameters when navigating
            const urlParams = new URLSearchParams(window.location.search);
            const lat = urlParams.get("lat");
            const lng = urlParams.get("lng");
            const metropolitanArea = urlParams.get("metropolitan_area");

            // Build URL with date and all preserved parameters
            let newUrl = `/explore/chef?date=${data}`;
            if (lat && lng) {
              newUrl += `&lat=${lat}&lng=${lng}`;
            }
            if (metropolitanArea) {
              newUrl += `&metropolitan_area=${encodeURIComponent(metropolitanArea)}`;
            }

            history.push(newUrl);
          }}
        />
        <SectionFood
          searched=""
          selectedChef={selectedChef}
          setChef={(data) => WhichChef(data)}
          lang={selectedLang}
          list={culinariansList}
          load={load}
          onTabChange={(tab) => setSelectedTab(tab)}
        />
      </div>
    </div>
  );
};

export default LayoutHomeChef;

const post_selected_when = (data) => ({
  type: POST_SELECTED_WHEN,
  data: data
});

const post_selected_chef = (data) => ({
  type: POST_SELECTED_CHEF,
  data: data
});


